import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import axios from 'axios';

const BannerOne = () => {
    const [sliders, setSliders] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5196';
    // Görsel URL'lerini birleştirmek için API base URL'i (sonunda /api olmadan)
    const imageApiUrl = (process.env.REACT_APP_IMAGE_API_URL || process.env.REACT_APP_API_URL || API_URL).replace(/\/api\/?$/,'');

    // API'den slider verilerini çek
    useEffect(() => {
        const fetchSliders = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${API_URL}/sliders/active`);
                if (response.data.succeeded) {
                    // ImageUrl değerlerini düzelt
                    const processedSliders = response.data.sliders.map(slider => {
                        let path = slider.imageUrl || '';
                        // Başında /api varsa kaldır
                        path = path.replace(/^\/api\/?/, '/');
                        const fullUrl = path.startsWith('http') ? path : `${imageApiUrl}${path}`;
                        return {
                            ...slider,
                            imageUrl: fullUrl
                        };
                    });
                    setSliders(processedSliders);
                }
            } catch (error) {
                console.error('Slider verileri çekilirken hata oluştu:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSliders();
    }, []);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        autoplaySpeed: 5000,
    };
    
    // Slider içeriğini render et (her zaman Slider bileşeni ile)
    const renderSliderContent = () => {
        if (loading) {
            return (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                </div>
            );
        }
        
        // Eğer hiç slider yoksa varsayılan içerik göster
        if (sliders.length === 0) {
            return (
                <div className="banner-slider__inner position-relative justify-content-center text-center">
                    <div className="banner-item__content mx-auto max-w-3xl">
                        <div className="mb-32">
                            <img 
                                src="/assets/images/logo/logo.png" 
                                alt="Gümüş Pestil Logo" 
                                className="mx-auto d-block"
                                style={{ maxWidth: '200px', height: 'auto' }}
                            />
                        </div>
                        <h1 className="banner-item__title bounce">
                            Gümüş Pestil'e Hoş Geldiniz
                        </h1>
                        <p className="mb-12">
                            Doğal ve lezzetli ürünlerimizi keşfedin. Geleneksel tatlar, modern dokunuşlarla sizlerle.
                        </p>
                        <Link
                            to="/shop"
                            className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8"
                        >
                            Ürünleri İnceleyin
                            <span className="icon text-xl d-flex">
                                <i className="ph ph-arrow-right" />
                            </span>
                        </Link>
                    </div>
                </div>
            );
        }
        
        // Tek slider varsa slider bileşeni kullanma
        if (sliders.length === 1) {
            const slider = sliders[0];
            const hasImage = slider.imageUrl && slider.imageUrl.trim() !== '';
            return (
                <div className={`banner-slider__inner position-relative ${hasImage ? 'flex-between' : 'justify-content-center text-center'}`}>
                    <div className={`banner-item__content ${!hasImage ? 'mx-auto max-w-3xl' : ''}`}>
                        <h1 className="banner-item__title bounce">
                            {slider.title}
                        </h1>
                        {slider.description?.trim() && <p className="mb-12">{slider.description}</p>}
                        {slider.buttonText?.trim() && (
                            <Link
                                to={slider.buttonUrl || '/'}
                                className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8"
                            >
                                {slider.buttonText}
                                <span className="icon text-xl d-flex">
                                    <i className="ph ph-arrow-right" />
                                </span>
                            </Link>
                        )}
                    </div>
                    {hasImage && (
                        <div className="banner-item__thumb">
                            <img
                                src={slider.imageUrl}
                                alt={slider.title}
                                className="object-cover rounded-16"
                                style={{ 
                                    maxHeight: '400px', 
                                    height: '100%', 
                                    width: '100%', 
                                    objectFit: 'contain' 
                                }}
                            />
                        </div>
                    )}
                </div>
            );
        }
        return (
            <Slider {...settings}>
                {sliders.map((slider) => {
                    const hasImage = slider.imageUrl && slider.imageUrl.trim() !== '';
                    return (
                        <div key={slider.id} className="banner-slider__item">
                            <div className={`banner-slider__inner position-relative ${hasImage ? 'flex-between' : 'justify-content-center text-center'}`}>
                                <div className={`banner-item__content ${!hasImage ? 'mx-auto max-w-3xl' : ''}`}>
                                    <h1 className="banner-item__title bounce">
                                        {slider.title}
                                    </h1>
                                    {slider.description?.trim() && <p className="mb-12">{slider.description}</p>}
                                    {slider.buttonText?.trim() && (
                                        <Link
                                            to={slider.buttonUrl || '/'}
                                            className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8"
                                        >
                                            {slider.buttonText}
                                            <span className="icon text-xl d-flex">
                                                <i className="ph ph-arrow-right" />
                                            </span>
                                        </Link>
                                    )}
                                </div>
                                {hasImage && (
                                    <div className="banner-item__thumb">
                                        <img
                                            src={slider.imageUrl}
                                            alt={slider.title}
                                            className="object-cover rounded-16"
                                            style={{ 
                                                maxHeight: '400px', 
                                                height: '100%', 
                                                width: '100%', 
                                                objectFit: 'contain' 
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </Slider>
        );
    };
    
    return (
        <div className="banner">
            <div className="container container-lg">
                <div className="banner-item rounded-24 overflow-hidden position-relative arrow-center">
                    <a
                        href="#featureSection"
                        className="scroll-down w-84 h-84 text-center flex-center bg-main-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x bottom-0 hover-bg-main-800"
                    >
                        <span className="icon line-height-0">
                            <i className="ph ph-caret-double-down" />
                        </span>
                    </a>
                    <img
                        src="/assets/images/bg/banner-bg.png"
                        alt=""
                        className="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
                    />
                    <div className="banner-slider">
                        {renderSliderContent()}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerOne